"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Annotation, CoreModel } from "@ym-framework/model";
export let RolelistModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.role = "";
    this.department = [];
    this.original_password = "";
    this.account = "";
    this.name = "";
    this.shop_count = 0;
    this.vd_count = 0;
    this.comment = "";
    this.guid = "";
    this.device_limit_type = "";
    this.login_limit_time = "";
    this.nickname = "";
    this.phone = 0;
    this.lock = false;
    this.role_name = "";
  }
};
RolelistModel.model = "sub_account";
RolelistModel = __decorateClass([
  Annotation.ModelMeta
], RolelistModel);
export let DepartmentModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.name = "";
    this.id = "";
  }
};
DepartmentModel.model = "department.model";
DepartmentModel = __decorateClass([
  Annotation.ModelMeta
], DepartmentModel);
